/* erx-pp.js - accessory / part product pages (sections/erx-pp-*.liquid). Ships with assets/erx-pp.css.
   Buying stays with assets/cart.js: every "Į krepšelį" is a plain button (data-erx-pp-atc) and this file calls
   window.cart.addToCart(variant, 1) once per click (no form submit, so analytics counts one add), like the chair page.
   It also keeps #variant-id-input in step with the chosen options, and runs the gallery, the tab bar and the FAQ. */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesk = () => window.matchMedia('(min-width: 1025px)').matches;

  /* ---------------- FAQ ---------------- */
  document.addEventListener('click', e => {
    const b = e.target.closest && e.target.closest('[data-erx-pp-faq]');
    if (!b) return;
    const item = b.closest('.erx-pp-faq__it'), panel = item && $('.erx-pp-faq__a', item);
    const open = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (item) item.classList.toggle('is-open', open);
    if (panel) panel.hidden = !open;
  });

  document.addEventListener('click', e => {
    const b = e.target.closest && e.target.closest('[data-erx-pp-notify-proxy]');
    if (!b) return;
    const main = $('[data-erx-pp-notify]');
    if (main) main.click();
  });

  /* ---------------- add to cart: buy box, phone bar, tab bar, closing block ---------------- */
  let adding = false;
  document.addEventListener('click', e => {
    const btn = e.target.closest && e.target.closest('[data-erx-pp-atc]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || adding) return;
    const input = $('#variant-id-input');
    const id = input && input.value;
    if (!id) return;
    if (!(window.cart && window.cart.addToCart)) { const f = $('#product-form'); if (f) f.submit(); return; }
    adding = true;
    const done = () => { adding = false; };
    const guard = setTimeout(done, 10000);
    const qi = $('#product-form input[name="quantity"]');
    const qty = Math.max(1, parseInt(qi && qi.value, 10) || 1);
    Promise.resolve(window.cart.addToCart(id, qty)).catch(() => {}).then(() => { clearTimeout(guard); done(); });
  });

  /* ---------------- in-page scrolling (phone: the two top bars hide going down, return going up) ---------------- */
  function scrollToEl(el) {
    const behavior = reduceMotion ? 'auto' : 'smooth';
    if (isDesk()) { el.scrollIntoView({ behavior, block: 'start' }); return; }
    const bar = $('[data-erx-pp-tabs]');
    const barH = bar && getComputedStyle(bar).position === 'sticky' ? bar.offsetHeight : 0;
    const top = el.getBoundingClientRect().top;
    const down = top > 82 + barH + 17;
    /* sticky bars v2 (html.erx-sb): the header steps aside during the jump, the tab bar is at the very top */
    const head = document.documentElement.classList.contains('erx-sb') ? 0 : (down ? 52 : 82);
    window.scrollTo({ top: Math.max(0, window.scrollY + top - (head + barH + 16)), behavior });
  }

  /* =====================================================================================
     TOP: options, prices, gallery
     ===================================================================================== */
  const initTop = () => {
    const top = $('[data-erx-pp-top]'), dataEl = $('#erx-pp-data');
    if (!top || !dataEl) return;
    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const T = data.t || {};
    const variants = data.variants || [];
    const input = $('#variant-id-input');
    let variant = variants.find(v => String(v.id) === String(input && input.value)) || variants[0];
    if (!variant) return;
    const sample = ($('[data-erx-pp-now]', top) || {}).textContent || '';
    const money = cents => {
      if (typeof window.formatMoney === 'function') return window.formatMoney(Math.round(cents));
      const n = (Math.round(cents) / 100).toFixed(2), [i, d] = n.split('.');
      const comma = /\d,\d{2}(?!\d)/.test(sample) || !/\d\.\d{2}(?!\d)/.test(sample);
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, comma ? ' ' : ',') + (comma ? ',' : '.') + d + ' €';
    };
    const moneyT = c => money(c).replace(/([,.])00(?!\d)/, '');
    const fromLabel = $('[data-erx-pp-from]', top);
    /* the variant with this value at option k and the current choice everywhere else */
    const withValue = (k, val) => variants.find(x => x.o[k] === val && x.o.every((y, j) => j === k || y === null || y === variant.o[j]));
    let userPicked = false;
    /* Perku: Įmonei = quantity stepper and the unit price after the automatic B2B discount (Shopify applies it in the
       cart: 3-4 -5 %, 5-9 -8 %, 10-29 -13 %, 30+ -20 %, same table as the chair page) */
    let mode = 'me', qty = 3;
    const TIERS = [[30, 20], [10, 13], [5, 8], [3, 5]];
    const tierPct = q => (TIERS.find(t => q >= t[0]) || [0, 0])[1];

    const paint = () => {
      const showFrom = fromLabel && !userPicked;
      const isBiz = mode === 'biz', bp = isBiz ? tierPct(qty) : 0;
      const unit = Math.round(variant.price * (100 - bp) / 100);
      $$('[data-erx-pp-price]').forEach(box => {
        const now = $('[data-erx-pp-now]', box), pct = $('[data-erx-pp-pct]', box), was = $('[data-erx-pp-was]', box);
        const from = $('[data-erx-pp-from]', box), un = $('[data-erx-pp-unit]', box);
        if (from && !showFrom) from.hidden = true;
        if (now && !(from && showFrom)) now.textContent = money(unit);
        if (un) un.hidden = !isBiz;
        if (isBiz) {
          if (was) { was.hidden = !bp; was.textContent = money(variant.price); }
          if (pct) { pct.hidden = !bp; pct.textContent = '−' + bp + ' %'; }
          return;
        }
        const sale = variant.was > variant.price;
        if (was) { was.hidden = !sale; if (sale) was.textContent = money(variant.was); }
        if (pct) { pct.hidden = !sale || !variant.available; if (sale) pct.textContent = '−' + Math.round((variant.was - variant.price) * 100 / variant.was) + ' %'; }
      });
      $$('[data-erx-pp-biz]', top).forEach(el => { el.hidden = !isBiz; });
      const qo = $('[data-erx-pp-qty]', top); if (qo) qo.textContent = qty;
      const qi = $('#product-form input[name="quantity"]'); if (qi) qi.value = isBiz ? qty : 1;
      const avail = variant.available !== false;
      $$('[data-erx-pp-outchip]').forEach(c => { c.hidden = avail; });
      $$('[data-erx-pp-atc]').forEach(b => {
        b.disabled = !avail;
        if (!b.hasAttribute('data-erx-pp-bar-atc')) b.textContent = avail ? T.atc : T.soldOut;
      });
      $$('[data-erx-pp-barprice]').forEach(el => { el.textContent = money(unit * (isBiz ? qty : 1)); });
      /* [o1] [o2] [o3] in the bar line and the summary: the chosen value's label (tile name in the bar) */
      const label = k => { const val = variant.o[k] || ''; const g = $(`[data-erx-pp-opt="${k}"]`, top); const b = g && $$('[data-erx-pp-val]', g).find(x => x.dataset.erxPpVal === val); return (b && b.dataset.label) || val; };
      const name = k => { if (k === data.tk) { const i = (data.tvals || []).indexOf(variant.o[k]); if (i >= 0 && data.tnames && data.tnames[i]) return data.tnames[i]; } return label(k); };
      const sub = $('[data-erx-pp-barsub]');
      if (sub) {
        const bar = String(data.bar || sub.dataset.def || '').replace(/\[o(\d)\]/g, (m, n) => name(+n - 1));
        sub.textContent = avail ? bar : T.soldOut;
      }
      const sumT = $('[data-erx-pp-sumt]', top), sumP = $('[data-erx-pp-sump]', top);
      if (sumT && data.sum) sumT.textContent = data.sum.replace(/\[o(\d)\]/g, (m, n) => label(+n - 1));
      if (sumP) sumP.textContent = money(unit);
      if (input) input.value = variant.id;
      window.currentSelectedVariant = String(variant.id);
      /* option pickers */
      $$('[data-erx-pp-opt]', top).forEach(g => {
        const k = +g.dataset.erxPpOpt, val = variant.o[k];
        const lab = $('[data-erx-pp-optval]', g);
        const onBtn = $$('[data-erx-pp-val]', g).find(b => b.dataset.erxPpVal === val);
        if (lab) lab.textContent = (onBtn && onBtn.dataset.label) || val;
        /* pills with a price: the price of that choice with the current other options */
        $$('.erx-pp-pill [data-erx-pp-pillpr]', g).forEach(sp => {
          const tv = withValue(k, sp.closest('[data-erx-pp-val]').dataset.erxPpVal);
          sp.textContent = tv ? ' \u00b7 ' + moneyT(tv.price) : '';
        });
        /* photo tiles: picture and price of that choice with the current other options */
        $$('.erx-pp-tl', g).forEach(t => {
          const tv = withValue(k, t.dataset.erxPpVal);
          if (!tv) return;
          const spans = $$('.erx-pp-tl__ph > [data-vid]', t);
          if (spans.some(x => x.dataset.vid === String(tv.id))) spans.forEach(x => { x.hidden = x.dataset.vid !== String(tv.id); });
          const pr = $('[data-erx-pp-tlpr]', t);
          if (pr) pr.innerHTML = '<b>' + moneyT(tv.price) + '</b>' + (tv.was > tv.price ? '<s>' + moneyT(tv.was) + '</s>' : '');
        });
        $$('[data-erx-pp-val]', g).forEach(b => {
          const on = b.dataset.erxPpVal === val;
          b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
          /* sold out: no variant with this value and the other current choices can be bought */
          const out = !variants.some(v => v.available && v.o.every((x, j) => j === k ? x === b.dataset.erxPpVal : (x === null || x === variant.o[j])));
          b.classList.toggle('is-out', out);
        });
      });
    };

    /* ---- desktop gallery ---- */
    const dmain = $('[data-erx-pp-dmain]', top);
    const rail = dmain && $('.erx-pp-dgal__rail', dmain);
    const dprev = $('[data-erx-pp-dprev]', top), dnext = $('[data-erx-pp-dnext]', top);
    const slots = dmain ? $$('.erx-pp-dgal__slot', dmain) : [];
    const thumbs = () => (rail ? $$('.erx-pp-dgal__th', rail).filter(t => !t.hidden) : []);
    const dshow = g => {
      slots.forEach(s => { const on = s.dataset.g === String(g); s.hidden = !on; s.classList.toggle('is-on', on); if (on) { const im = $('img', s); if (im && im.loading === 'lazy') im.loading = 'eager'; } });
      thumbs().forEach(t => t.classList.toggle('is-on', t.dataset.g === String(g)));
      const list = thumbs(), i = list.findIndex(t => t.dataset.g === String(g));
      if (dprev) dprev.hidden = false; /* the arrows wrap round: before the first is the last */
    };
    if (rail) {
      rail.addEventListener('click', e => { const th = e.target.closest('.erx-pp-dgal__th'); if (th) dshow(th.dataset.g); });
      const step = d => { const list = thumbs(), i = list.findIndex(t => t.classList.contains('is-on')); const nx = list[(i + d + list.length) % list.length]; if (nx) dshow(nx.dataset.g); };
      if (dnext) dnext.addEventListener('click', () => step(1));
      if (dprev) dprev.addEventListener('click', () => step(-1));
    }
    /* the main plate as tall as the buy column (owner, OmniARM 2026-10-11); measured with the accordions closed */
    const buy = $('[data-erx-pp-buy]', top);
    const fit = () => {
      if (!top.classList.contains('is-fill') || !dmain || !buy) return;
      if (!isDesk()) { dmain.style.height = ''; dmain.classList.remove('is-sized'); return; }
      if ($$('details[open]', buy).length) return;
      const h = Math.max(buy.offsetHeight, dmain.offsetWidth);
      dmain.style.height = h + 'px'; dmain.classList.add('is-sized');
    };

    /* ---- phone gallery ---- */
    const track = $('[data-erx-pp-ptrack]', top), dotsEl = $('[data-erx-pp-pdots]', top);
    const pslides = () => (track ? $$('.erx-pp-pgal__slide', track).filter(s => !s.hidden) : []);
    const syncDots = () => {
      if (!track || !dotsEl) return;
      const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      $$('span', dotsEl).forEach((d, k) => d.classList.toggle('is-on', k === i));
    };
    const buildDots = () => {
      if (!dotsEl) return;
      const n = pslides().length;
      dotsEl.innerHTML = n > 1 ? '<span></span>'.repeat(n) : '';
      syncDots();
    };
    if (track) { let raf = 0; track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(syncDots); }, { passive: true }); }

    /* ---- pictures that belong to one option value (e.g. the dark felt photos) ---- */
    const applyFilters = () => {
      $$('[data-ov]', top).forEach(el => {
        const i = el.dataset.ov.indexOf('|'), k = +el.dataset.ov.slice(0, i), v = el.dataset.ov.slice(i + 1);
        el.hidden = variant.o[k] !== v;
      });
      /* variant pictures limited to the current value of one option (OmniGO: the four colours of the chosen size) */
      $$('[data-same]', top).forEach(el => {
        const i = el.dataset.same.indexOf('|'), k = +el.dataset.same.slice(0, i), v = el.dataset.same.slice(i + 1);
        el.hidden = variant.o[k] !== v;
      });
      /* the picture on show was filtered away: show the first one left */
      const vis = thumbs();
      if (vis.length && !vis.some(t => t.classList.contains('is-on'))) dshow(vis[0].dataset.g);
    };

    /* ---- variant → gallery ---- */
    const showVariantImage = (initial) => {
      applyFilters();
      /* "selected only" variant slots follow the variant */
      $$('[data-mode="selected"][data-vid]', top).forEach(el => {
        const on = el.dataset.vid === String(variant.id);
        if (el.classList.contains('erx-pp-dgal__slot')) return;
        el.hidden = !on;
      });
      const th = rail && $$('.erx-pp-dgal__th[data-vid]', rail).find(t => t.dataset.vid === String(variant.id));
      if (th && !initial) dshow(th.dataset.g);
      if (track) {
        buildDots();
        const sl = pslides(), i = sl.findIndex(s => s.dataset.vid === String(variant.id));
        if (i >= 0) {
          const im = $('img', sl[i]); if (im && im.loading === 'lazy') im.loading = 'eager';
          if (!initial || i > 0) track.scrollTo({ left: i * track.clientWidth, behavior: initial || reduceMotion ? 'auto' : 'smooth' });
        }
      }
    };

    const select = (k, val) => {
      const want = variant.o.slice(); want[k] = val;
      const match = o => variants.find(v => v.o.every((x, j) => x === null || x === o[j]));
      let v = match(want);
      if (!v || !v.available) {
        /* keep the clicked value, take the closest buyable combination */
        const alt = variants.filter(x => x.o[k] === val).sort((a, b) => (b.available - a.available) || (b.o.filter((x, j) => x === want[j]).length - a.o.filter((x, j) => x === want[j]).length))[0];
        if (!v || (alt && alt.available)) v = alt;
      }
      if (!v) return;
      const changed = v !== variant;
      variant = v; userPicked = true;
      paint();
      if (changed) {
        showVariantImage(false);
        try { const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(history.state, '', url); } catch (e) {}
      }
    };
    top.addEventListener('click', e => {
      const m = e.target.closest('[data-erx-pp-mode]');
      if (m) {
        mode = m.dataset.erxPpMode;
        $$('[data-erx-pp-mode]', top).forEach(x => { const on = x === m; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        paint(); return;
      }
      const q = e.target.closest('[data-erx-pp-q]');
      if (q) { qty = Math.max(1, Math.min(999, qty + (+q.dataset.erxPpQ))); paint(); return; }
      const b = e.target.closest('[data-erx-pp-val]');
      if (!b) return;
      const g = b.closest('[data-erx-pp-opt]');
      if (g) select(+g.dataset.erxPpOpt, b.dataset.erxPpVal);
    });

    showVariantImage(true);
    paint();
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    window.addEventListener('load', () => {
      fit();
      /* warm the other gallery pictures once the page is in: desktop only, the slots belong to the desktop gallery, which is
         display:none on phones, where this pulled every picture (mat page: ~1.3 MB) for a gallery nobody sees (2026-10-12) */
      setTimeout(() => { if (!dmain || !dmain.getClientRects().length) return; slots.forEach(s => { const im = $('img', s); if (im && im.loading === 'lazy') im.loading = 'eager'; }); }, 1500);
    });
    let rt = 0; window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(fit, 120); }, { passive: true });
  };

  /* =====================================================================================
     TAB BAR: sticky in CSS; active pill + "stuck" from one cheap read per frame
     ===================================================================================== */
  const initTabs = () => {
    const bar = $('[data-erx-pp-tabs]'), sentinel = $('[data-erx-pp-tabs-sentinel]');
    if (!bar) return;
    const nav = $('[data-erx-pp-tabs-nav]', bar);
    const links = $$('[data-erx-pp-tab]', bar);
    const targetOf = a => document.getElementById(a.getAttribute('href').slice(1));
    let current = null, lockUntil = 0;
    const setActive = a => {
      if (!a || a === current) return;
      current = a;
      links.forEach(x => { const on = x === a; x.classList.toggle('is-on', on); if (on) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); });
      if (nav && nav.scrollWidth > nav.clientWidth) {
        const l = a.offsetLeft - 16, r = a.offsetLeft + a.offsetWidth + 24;
        if (l < nav.scrollLeft || r > nav.scrollLeft + nav.clientWidth) nav.scrollTo({ left: Math.max(0, l), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    };
    links.forEach(a => a.addEventListener('click', e => {
      const t = targetOf(a);
      if (!t) return;
      e.preventDefault();
      lockUntil = performance.now() + 1100;
      setActive(a);
      scrollToEl(t);
    }));
    const evaluate = () => {
      const t = parseFloat(getComputedStyle(bar).top) || 0;
      if (sentinel) bar.classList.toggle('is-stuck', sentinel.getBoundingClientRect().top < t - 0.5 && Math.abs(bar.getBoundingClientRect().top - t) < 2);
      if (performance.now() < lockUntil) return;
      const line = t + bar.offsetHeight + 24;
      let pick = null;
      links.forEach(a => { if (a.offsetParent === null) return; const el = targetOf(a); if (el && el.offsetParent !== null && el.getBoundingClientRect().top <= line) pick = a; });
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) pick = links.filter(a => a.offsetParent !== null).pop() || pick;
      setActive(pick || links[0]);
    };
    let raf = 0;
    const tick = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; evaluate(); }); };
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick, { passive: true });
    window.addEventListener('pageshow', () => { lockUntil = 0; tick(); });
    evaluate();
    if (!('IntersectionObserver' in window)) return;
    const ft = document.querySelector('.erx-ft, footer');
    if (ft) new IntersectionObserver(es => es.forEach(e => { bar.classList.toggle('is-away', e.isIntersecting); }), { threshold: 0 }).observe(ft);
  };

  const init = () => { initTop(); initTabs(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
